import { render } from "./Coupons.vue?vue&type=template&id=cd04dd4a&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"

import "./Coupons.vue?vue&type=style&index=0&id=cd04dd4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd04dd4a"]])

export default __exports__